var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    [
      _vm.rowData["finishedSubstrateState"] === "成品料"
        ? _c("span", [_vm._v("成品料")])
        : _c(
            "el-popover",
            {
              attrs: { placement: "bottom", width: "400", trigger: "click" },
              on: {
                "after-enter": function ($event) {
                  return _vm.getProcessPlateList(_vm.rowData["id"])
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  key: "process" + _vm.rowData["id"],
                  attrs: {
                    size: "mini",
                    data: _vm.tableData,
                    "header-cell-style": { background: "rgba(245,247,250,1)" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { property: "processMode", label: "二次工艺类型" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { property: "processName", label: "二次工艺名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      property: "processDescription",
                      label: "工艺需求描述",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-right": "5px",
                    color: "#ff8850",
                    "text-decoration": "underline",
                    cursor: "pointer",
                  },
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [_vm._v("底料")]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }